import { Action } from '../../common/actions/core/action';
import { PaymentMethod } from '../services/payment-method.model';

export class OpenCardAddContractAction implements Action {
  constructor(public onApprove: () => any) {}
}



// WEBPACK FOOTER //
// src/app/buy/card-add-contract-dialog/card-add-contract-dialog.action.ts